"use client";

import { useId } from "react";
import styles from "./AnalyticsConsent.module.css";

export interface AnalyticsConsentStrings {
  title: string;
  notice: string;
  learnMore: string;
  necessaryOnly: string;
  acceptAnalytics: string;
  settings: string;
}

export function AnalyticsConsentPanel({
  strings,
  onChoose,
  href = "/cookies",
}: {
  strings: AnalyticsConsentStrings;
  onChoose: (accepted: boolean) => void;
  href?: string;
}) {
  const titleId = useId();
  return (
    <section aria-labelledby={titleId} className={styles.panel}>
      <h2 id={titleId} className={styles.title}>{strings.title}</h2>
      <p className={styles.notice}>{strings.notice}</p>
      <a href={href} className={styles.learnMore}>{strings.learnMore}</a>
      <div className={styles.actions}>
        <button type="button" onClick={() => onChoose(false)} className={styles.choice}>
          {strings.necessaryOnly}
        </button>
        <button type="button" onClick={() => onChoose(true)} className={styles.choice}>
          {strings.acceptAnalytics}
        </button>
      </div>
    </section>
  );
}

export function AnalyticsSettingsButton({
  label,
  onClick,
  floating = false,
  dock = false,
}: {
  label: string;
  onClick: () => void;
  floating?: boolean;
  dock?: boolean;
}) {
  const button = (
    <button type="button" onClick={onClick} className={floating ? styles.settingsButton : styles.footerButton}>
      {label}
    </button>
  );
  return dock ? <div className={styles.settingsDock}>{button}</div> : button;
}
